import React, { useContext, useEffect, useState } from 'react';
import TextEditor from './TextEditor';
import { GlobalContext } from '../../../utils/ContextProviders/GlobalContextProvider';
import { postKelsey } from '../../../Redux/networkClient';
import { Path } from '../../../Redux/util/path';
import './chat-styles.scss';
import SmsEmailOption from '../SmsEmailOption.js';

const ChatInputBar = props => {
  const {
    selectedLeadId,
    messageInput,
    setMessageInput,
    isArchived,
    onClick,
    preference,
    apartmentId,
    leadUpdateMutate,
    setArchiveClick,
    archiveClick,
    userId,
    updatedLeadId,
    messageSent,
    handleOutgoingMessage,
    newNoteInsertionInProgress,
    handleNoteCreation,
    handleCallLogCreation,
    textOptIn,
    emailOptIn,
    updateHeight,
    leadTenantId,
    handleOutgoingScheduledMessage,
    isBotActive,
    apartmentTimezone

    // disabled,
  } = props;
  const { userData } = useContext(GlobalContext);

  const [medium, setMedium] = useState('sms');
  const [openMessageSendingLoader, setOpenMessageSendingLoader] =
    useState(false);
  const [appear, setAppear] = useState(false);

  const [messageStatus, setMessageStatus] = useState(false);
  const tenantId = userData.tenantId;

  return (
    <>
      <div className="chatInputBox">
        <div className="more-chat-options">
          <div style={{ display: 'flex' }}>
            {openMessageSendingLoader && messageStatus ? (
              <div>Loading...</div>
            ) : !messageStatus && messageSent === 'failed' && appear ? (
              <div>Try again after some time</div>
            ) : null}
          </div>
        </div>
        <div className="d-flex-align-center">
          <div
            style={{
              width: '100%'
            }}
          >
            <TextEditor
              custStyle={{
                width: '100%',
                maxHeight: '400px',
                marginTop: '55px',
                borderRadius: '4px'
              }}
              updateHeight={updateHeight}
              smsEmailOption={
                <SmsEmailOption {...{ medium, setMedium, setMessageInput }} />
              }
              {...{
                selectedLeadId,
                messageInput,
                setMessageInput,
                isArchived,
                onClick,
                preference,
                apartmentId,
                leadUpdateMutate,
                setArchiveClick,
                archiveClick,
                userId,
                updatedLeadId,
                messageSent,
                handleOutgoingMessage,
                newNoteInsertionInProgress,
                handleNoteCreation,
                handleCallLogCreation,
                textOptIn,
                emailOptIn,
                updateHeight,
                leadTenantId,
                isBotActive,
                tenantId,
                medium,
                setMedium,
                appear,
                setAppear,
                setOpenMessageSendingLoader,
                messageStatus,
                setMessageStatus,
                handleOutgoingScheduledMessage,
                apartmentTimezone
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatInputBar;
